import { type ClusterCreateSearchParams } from '@/router/utils';

export function isFreeTemplate(template: ClusterCreateSearchParams['template']) {
  return template === 'free';
}
